@if (component) {
<div class="bg-col-5">
    <div class="w-12 large-carousel">
        <div class="m-l-20 m-l-4-s m-l-4-m p-l-20-x p-l-20 p-r-10 p-l-0-m p-a-0-s flex flex-justify-between">
            <span class="h1 p-b-6 p-t-20 p-t-10-m p-t-4-s"
                  sizeClass="XLM:h1, S:h2"
                  *iCms="'section_title' of component"></span>
            <div class="p-t-20 p-t-10-m p-t-4-s p-b-6 p-b-7-m p-b-7-m p-r-4-s flex flex-middle"
                 *ifSize="'!SM'">
                <ng-container *ngTemplateOutlet="arrowNavigation;"></ng-container>
            </div>
        </div>
        <div class="pos-relative">
            <div *ifSize="'SM'"
                 class="pos-absolute z-2 left-1 right-1 flex flex-justify-between arrow-navigation">
                <ng-container *ngTemplateOutlet="arrowNavigation;"></ng-container>
            </div>
            <carousel class="p-b-20 p-b-0-s p-l-4-s p-l-4-m p-r-4-s p-r-4-m"
                      [slidesPerView]="slidesPerView"
                      [centeredSlides]="true"
                      [navigation]="{
                    nextEl: '.product-next-' + uid,
                    prevEl: '.product-prev-' + uid
                }"
                      [spaceBetween]="0"
                      [scrollbar]="false"
                      [loop]="true">
                @for (item of component.slides; track item) {
                <ng-template swiperSlide
                             class="p-b-0">
                    <div class="flex flex-justify-center flex-column">
                        <href [link]="item.image_link">
                            <div class="w-12 ratio-5-2-x ratio-5-2-l ratio-16-9-s ratio-16-9-m"
                                 [ngClass]="item.bg_color || ''">
                                <img class="large-carousel-image rf"
                                     [image]="item.image">
                                @if (component.variant !== 'textBelowImage') {
                                <div *ifSize="'!SM'"
                                     class="inside-text w-12 m-b-5 m-l-7 p-b-20 p-l-12 pos-absolute left-0 bottom-0 z-5">
                                    <ng-container *ngTemplateOutlet="captions; context:{$implicit:item}">
                                    </ng-container>
                                </div>
                                }
                            </div>
                        </href>
                        <!-- copies below image variant -->
                        @if (component.variant === 'textBelowImage') {
                        <div class="w-12 text-below"
                             [ngClass]="'ta-' + component.text_align || 'left'"
                             *ifSize="'!SM'">
                            <div class="p-l-12 p-r-12 m-l-7 m-r-7 m-t-5 z-5">
                                <ng-container *ngTemplateOutlet="captions; context:{$implicit:item}">
                                </ng-container>
                            </div>
                        </div>
                        }
                        <div *ifSize="'SM'"
                             class="inside-text p-t p-b-10-s">
                            <p class="o1 col-11 ls-2 uppercase fw-bold"
                               *iCms="'title_1' of component"></p>
                            <p class="h2 col-1 m-t-2"
                               *iCms="'main_title' of component"></p>
                            @if (item.cta_copy) {
                            <href [link]="item.cta_link"
                                  class="b-b p-b-1 p1 m-t-2 m-b-6 col-1 b-col-1">{{item.cta_copy}}</href>
                            }
                        </div>
                    </div>
                </ng-template>
                }
            </carousel>
        </div>
    </div>
</div>
}

<ng-template #captions
             let-item>
    <p class="o1 ls-2 uppercase"
       [ngClass]="item.color || ''"
       *iCms="'title_1' of component"></p>
    <p class="h2 m-t-2"
       *iCms="'main_title' of component"
       [ngClass]="item.color || ''"></p>
    @if (item.cta_copy) {
    <href [ngClass]="['b-' + (item.color || 'col-w'), item.color]"
          [link]="item.cta_link"
          class="b-b p-b-1 p1 m-t">{{item.cta_copy}}</href>
    }
</ng-template>

<ng-template #arrowNavigation>
    <button [ngClass]="'product-prev-' + uid"
            class="swiper-button m-r-5 bg-col-w box-shadow b-radius-max pos-relative"
            type="button"
            aria-label="Previous slide">
        <i class="icon-chevron-left b-radius-max fill flex flex-justify-center flex-middle swiper-button-icon"
           aria-hidden="true"></i>
    </button>
    <button [ngClass]="'product-next-' + uid"
            class="swiper-button bg-col-w box-shadow b-radius-max pos-relative"
            type="button"
            aria-label="Next slide">
        <i class="icon-chevron-right b-radius-max fill flex flex-justify-center flex-middle swiper-button-icon"
           aria-hidden="true"></i>
    </button>
</ng-template>
